// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"374":"3ceb9fdd","381":"de5e8093","525":"f162da81","780":"dc5823c6","781":"52bb9fc5","783":"e3d93a4a","827":"8c7e675b","894":"93b744ef"}[chunkId] + ".css";
};